/**
 * Data schemas for data retrieved from / sent to the staffMemberships back end.
 */

/** Which type of entity our staff memberships code is expressing. */
export enum StaffMembershipType {
  course = 'course',
  partner = 'partner',
  program = 'program',
}

/** Typing used by the backend. */
export type StaffMembershipTypeName = 'COURSE' | 'PARTNER' | 'DEGREE' | 'GROUP';

/**
 * The link between a user, a role, and another entity.
 */
export type StaffMembershipInterface = {
  id: string;
  /** Foreign key to role. */
  roleId: string;
  scope: {
    typeName: StaffMembershipTypeName;
    id: string | number;
  };
  /** Foreign key to user. */
  userId: number;
};

/**
 * Expected user information when dealing with users within the scope of staff management.
 */
export type StaffMembershipUserInterface = {
  email: string;
  fullName: string | undefined;
  id: number;
};

/**
 * Expected role information when dealing with roles within the scope of staff management.
 */
export type StaffMembershipRoleInterface = {
  id: string;
  name?: string;
  // `displayName` became preferred mid-development. The UI doesn't
  // translate anything, and already works with `name`.
  displayName?: string;
};
